import { useEffect, useState } from 'react';
import qs from 'qs';

const useLocationSearch = ({ location }) => {
    const [search, setSearch] = useState({});
    useEffect(() => {
        if (location) {
            const qParams = qs.parse(location.search, { ignoreQueryPrefix: true });
            setSearch(qParams);
        }
    }, [location]);

    return search;
};

export default useLocationSearch;
